export const RATIO_MODE = "ratio";
export const DEFAULT_RATIO = "16x9";

export const ASPECT_RATIOS = [
  { value: "1x1", label: "1 : 1" },
  { value: "4x3", label: "4 : 3" },
  { value: "3x4", label: "3 : 4" },
  { value: "3x2", label: "3 : 2" },
  { value: "2x3", label: "2 : 3" },
  { value: "16x9", label: "16 : 9" },
  { value: "9x16", label: "9 : 16" },
  { value: "21x9", label: "21 : 9" },
];

const WELL_FORMED_RATIO = /^(\d+)x(\d+)$/;

export function isWellFormedRatio(ratio) {
  if (typeof ratio !== "string") {
    return false;
  }
  const match = ratio.match(WELL_FORMED_RATIO);
  return match !== null && Number(match[1]) > 0 && Number(match[2]) > 0;
}

export function isRatioValue(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value) && value.mode === RATIO_MODE;
}

export function aspectForRatio(value) {
  const ratio = isRatioValue(value) ? value.ratio : value;
  if (typeof ratio !== "string") {
    return null;
  }
  const parts = ratio.split("x");
  if (parts.length !== 2) {
    return null;
  }
  const w = Number(parts[0]);
  const h = Number(parts[1]);
  if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
    return null;
  }
  return `${w} / ${h}`;
}

export function ratioOf(value) {
  return isRatioValue(value) ? value.ratio : DEFAULT_RATIO;
}

export function makeRatioValue(ratio) {
  return { mode: RATIO_MODE, ratio: ratio || DEFAULT_RATIO };
}
